const Shared = require("Sources/shared");
const Utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/language-manager");
const Carousel = require("Sources/components/recipe-carousel");

const imgNL1 = require("Data/coloring/nl1.pdf");
const imgNL2 = require("Data/coloring/nl2.pdf");
const imgNL3 = require("Data/coloring/nl3.pdf");
const imgNL4 = require("Data/coloring/nl4.pdf");

const imgFR1 = require("Data/coloring/fr1.pdf");
const imgFR2 = require("Data/coloring/fr2.pdf");
const imgFR3 = require("Data/coloring/fr3.pdf");
const imgFR4 = require("Data/coloring/fr4.pdf");

const calendarNl = require("Data/calendar/calendar_nl.pdf");
const calendarFr = require("Data/calendar/calendar_fr.pdf");

const rulesNl = require("Data/gamerules/rules_nl.pdf");
const rulesFr = require("Data/gamerules/rules_fr.pdf");


require("Styles/pages/activities.scss");

$(function()
{
  Shared.init();
  ActivitiesPage.init();
});

var ActivitiesPage = {};

((ActivitiesPage) =>
{
  var carousel;

  ActivitiesPage.init = function()
  {
    $(".act-recipe-img").hide();

    Utils.ImageSVGToSVG();

    setupLinks();

    setupCarousel();
  };

  function setupCarousel()
  {

    var element = $(".carousel-wrapper");

    carousel = new Carousel({
          element: element,
          centered: false,
          clickCallBack: onCarouselClicked
        });

    element.on("afterChange", function(event, slick, currentSlide)
    {
      var el = $(slick.$slides[currentSlide]).find(".recipe-slide");
      var id = el.data("recipe-id");

      window.location.hash = id;
    });

  }

  function onCarouselClicked(e)
  {
    var el = $(e.currentTarget).find(".recipe-slide");
    var id = el.data("recipe-id");

    $(".act-recipe-img").hide();
    $(".act-recipe-img." + id).show();

    $("#act-recipe-description-wide h2").html(LanguageManager.getValueForKey("recipes." + id + ".title"));
    $("#act-recipe-description h2").html(LanguageManager.getValueForKey("recipes." + id + ".title"));
    $("#act-recipe-description-wide div.recipe-description").html(LanguageManager.getValueForKey("recipes." + id + ".description"));
    $("#act-recipe-description div.recipe-description").html(LanguageManager.getValueForKey("recipes." + id + ".description"));

    $("#act-duration").html(LanguageManager.getValueForKey("recipes." + id + ".duration"));
    $("#act-persons").html(LanguageManager.getValueForKey("recipes." + id + ".persons"));

    $("#act-recipe-list-container").html(LanguageManager.getValueForKey("recipes." + id + ".ingredients"));

    window.location.hash = id;
  }

  function setupLinks()
  {
    $("a.img-nl-1").attr("href", imgNL1);
    $("a.img-nl-2").attr("href", imgNL2);
    $("a.img-nl-3").attr("href", imgNL3);
    $("a.img-nl-4").attr("href", imgNL4);

    $("a.img-fr-1").attr("href", imgFR1);
    $("a.img-fr-2").attr("href", imgFR2);
    $("a.img-fr-3").attr("href", imgFR3);
    $("a.img-fr-4").attr("href", imgFR4);

    var calendar;
    var rules;
    if(LanguageManager.getCurrentLocale() === "nl-BE")
    {
      calendar = calendarNl;
      rules = rulesNl;
    }
    else
    {
      calendar = calendarFr;
      rules = rulesFr;
    }

    $("#act-sow-button").on("click", function(e){
      window.open(window.location.origin + calendar, "_blank");
    });

    $("#act-boardgame-button").on("click", function(e){
      window.open(window.location.origin + rules, "_blank");
    });
  }


})(ActivitiesPage);



// WEBPACK FOOTER //
// ./app/js/entries/activities.js